var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBedExitFrequencyMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 19,
    viewBox: "0 0 30 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66632 8.36011L15.666 1.64011",
    stroke: "#CA0000",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.666 4.62622L15.666 1.63955L12.555 1.63955",
    stroke: "#CA0000",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3347 3.23999L17.335 9.95999",
    stroke: "#CA0000",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.335 6.97388V9.96054H20.4459",
    stroke: "#CA0000",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.695876 19C1.08006 19 1.39175 18.797 1.39175 18.5468V16.482H28.6082V18.5468C28.6082 18.797 28.9199 19 29.3041 19C29.6883 19 30 18.797 30 18.5468V8.97842C30 8.72819 29.6883 8.52518 29.3041 8.52518C28.9199 8.52518 28.6082 8.72819 28.6082 8.97842V13.1432H1.39175V5.45324C1.39175 5.20301 1.08006 5 0.695876 5C0.311695 5 0 5.20301 0 5.45324V18.5468C0 18.797 0.311695 19 0.695876 19ZM1.39175 15.5755V14.9712H28.6082V15.5755H1.39175Z",
    fill: "#CA0000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedExitFrequencyMarker);
export default __webpack_public_path__ + "static/media/bed-exit-frequency-marker.a6a410a0174e35e2d88f9b91b1215659.svg";
export { ForwardRef as ReactComponent };